<template>
  <div class="admin-layout">
    <!-- 侧边栏 -->
    <div class="sidebar">
      <div class="logo">
        <h2>管理后台</h2>
      </div>
      <nav class="menu">
        <router-link to="/admin/dashboard" class="menu-item">
          <el-icon><DataLine /></el-icon>
          <span>控制台</span>
        </router-link>
        <router-link to="/admin/homepage" class="menu-item">
          <el-icon><House /></el-icon>
          <span>主页管理</span>
        </router-link>
        <router-link to="/admin/users" class="menu-item">
          <el-icon><User /></el-icon>
          <span>用户管理</span>
        </router-link>
        <router-link to="/admin/vipcode" class="menu-item">
          <el-icon><User /></el-icon>
          <span>会员码管理</span>
        </router-link>
        <router-link to="/admin/materials" class="menu-item">
          <el-icon><Picture /></el-icon>
          <span>素材管理</span>
        </router-link>
        <router-link to="/admin/tags" class="menu-item">
          <el-icon><Picture /></el-icon>
          <span>标签管理</span>
        </router-link>
        <router-link to="/admin/tools" class="menu-item">
          <el-icon><SetUp /></el-icon>
          <span>工具管理</span>
        </router-link>
        <router-link to="/admin/custom" class="menu-item">
          <el-icon><Edit /></el-icon>
          <span>定制管理</span>
        </router-link>
        <router-link to="/admin/monetize" class="menu-item">
          <el-icon><Money /></el-icon>
          <span>变现渠道</span>
        </router-link>
        <router-link to="/admin/tutorials" class="menu-item">
          <el-icon><Reading /></el-icon>
          <span>教程管理</span>
        </router-link>
        <router-link to="/admin/tool-introductions" class="menu-item">
          <el-icon><Document /></el-icon>
          <span>工具介绍</span>
        </router-link>
      </nav>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 顶部栏 -->
      <header class="header">
        <div class="breadcrumb">
          {{ currentPath }}
        </div>
        <div class="user-info">
          <el-dropdown>
            <span class="user-name">
              {{ formatUsername(username) }}
              <el-icon><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showChangePassword">修改密码</el-dropdown-item>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </header>

      <!-- 内容区 -->
      <div class="content">
        <!-- 直接显示管理内容，不依赖userStore.isAdmin，而是使用从localStorage检查的状态 -->
        <div v-if="localIsAdmin">
          <h3>{{ getPageTitle() }}</h3>
          <el-divider />
          
          <!-- 根据当前路由显示不同内容 -->
          <div class="admin-content">
  <!-- 测试按钮 -->
  <!-- <el-button @click="testTagRoute">测试标签管理路由</el-button> -->
  <el-divider />
            <!-- 控制台/仪表盘内容 -->
            <div v-if="currentSection === 'dashboard'" class="dashboard-section">
              <el-card shadow="never">
                <template #header>
                  <div style="font-weight: bold;">控制台数据</div>
                </template>
                
                <!-- 显示加载状态 -->
                <div v-if="dashboardLoading" style="text-align: center; padding: 20px;">
                  <el-skeleton animated :rows="10" />
                  <p>正在加载控制台数据...</p>
                </div>
                
                <!-- 显示错误信息 -->
                <div v-else-if="dashboardError" style="text-align: center; padding: 20px; color: #F56C6C;">
                  <el-empty description="加载控制台数据失败">
                    <el-button type="primary" @click="retryLoadDashboard">
                      重试
                    </el-button>
                  </el-empty>
                </div>
                
                <!-- 显示Dashboard组件 -->
                <div v-else>
                  <Dashboard />
                </div>
              </el-card>
            </div>

            <!-- 主页管理内容 -->
            <div v-if="currentSection === 'homepage'" class="homepage-section">
              <Homepage />
            </div>
            
            <!-- 用户管理内容 -->
            <div v-if="currentSection === 'users'" class="users-section">
              <UserManagement />
            </div>
            <!-- 会员码管理内容 -->
            <div v-if="currentSection === 'vipcode'" class="users-section">
              <VipCodeManagement />
            </div>
            
            <!-- 工具管理内容 -->
            <div v-if="currentSection === 'tools'" class="tools-section">
              <ToolManagement />
            </div>
            
            <!-- 素材管理内容 -->
            <div v-if="currentSection === 'materials'" class="materials-section">
              <p>此处可以管理系统素材。</p>
              <Materials />
            </div>

            <!-- 标签管理内容 -->
            <div v-if="currentSection === 'tags'" class="tags-section">
              <p>此处可以管理素材标签。</p>
              <Tags />
            </div>
            
            <!-- 定制管理内容 -->
            <div v-if="currentSection === 'custom'" class="custom-section">
              <p>此处可以管理用户定制需求。</p>
              <CustomManagement />
            </div>
            
            <!-- 变现渠道管理内容 -->
            <div v-if="currentSection === 'monetize'" class="monetize-section">
              <p>此处可以管理变现渠道。</p>
              <MonetizeManagement />
            </div>
            
            <!-- 教程管理内容 -->
            <div v-if="currentSection === 'tutorials'" class="tutorials-section">
              <p>此处可以管理教程内容。</p>
              <TutorialManagement />
            </div>

            <!-- 工具介绍管理内容 -->
            <div v-if="currentSection === 'tool-introductions'" class="tool-introductions-section">
              <p>此处可以管理工具介绍内容，如简单画工具的介绍页面。</p>
              <ToolIntroductionManagement />
            </div>
          </div>
        </div>
        <div v-else>
          <el-empty description="您没有访问权限" />
        </div>
      </div>
    </div>

    <!-- 修改密码对话框 -->
    <ChangePasswordDialog ref="changePasswordDialogRef" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch, ref, markRaw, defineAsyncComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'
import {
  DataLine,
  House,
  User,
  Picture,
  Edit,
  ArrowDown,
  SetUp,
  Money,
  Reading,
  Document
} from '@element-plus/icons-vue'
import ChangePasswordDialog from '@/components/admin/ChangePasswordDialog.vue'
import NotificationManagement from '@/components/admin/NotificationManagement.vue'
import RequirementManagement from '@/components/admin/RequirementManagement.vue'
import Homepage from '@/views/admin/Homepage.vue'  // 导入Homepage组件
import CustomManagement from '@/views/admin/CustomManagement.vue'  // 使用正确的路径
import Materials from '@/views/admin/Materials.vue'  // 导入素材管理组件
import UserManagement from '@/views/admin/UserManagement.vue'  // 导入用户管理组件
import VipCodeManagement from '@/views/admin/VipCodeManagement.vue'  // 导入用户管理组件
import ToolManagement from '@/views/admin/ToolManagement.vue'  // 导入工具管理组件
import MonetizeManagement from '@/views/admin/MonetizeManagement.vue'  // 导入变现渠道管理组件
import TutorialManagement from '@/views/admin/TutorialManagement.vue'  // 导入教程管理组件
import ToolIntroductionManagement from '@/views/admin/ToolIntroductionManagement.vue'  // 导入工具介绍管理组件
import Tags from '@/views/admin/Tags.vue'  // 导入标签管理组件
// 异步导入Dashboard组件
const Dashboard = defineAsyncComponent(() => import('@/views/admin/Dashboard.vue'))

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

const currentPath = computed(() => route.name)
const username = computed(() => userStore.user?.username || localStorage.getItem('username') || '用户')
// 根据路由路径确定当前管理部分
const currentSection = computed(() => {
  const path = route.path;
  console.log('当前路由路径:', path);
  if (path === '/admin/dashboard') return 'dashboard';
  if (path === '/admin/homepage') return 'homepage';
  if (path === '/admin/users') return 'users';
  if (path === '/admin/vipcode') return 'vipcode';
  if (path === '/admin/materials') return 'materials';
  if (path === '/admin/tags') return 'tags';
  if (path === '/admin/tools') return 'tools';
  if (path === '/admin/custom') return 'custom';
  if (path === '/admin/monetize') return 'monetize';
  if (path === '/admin/tutorials') return 'tutorials';
  if (path === '/admin/tool-introductions') return 'tool-introductions';
  // 如果没有匹配的路径，默认显示控制台
  console.log('未匹配到路径，默认返回currentSection: dashboard');
  return 'dashboard';
})

const stats = ref({
  users: 256,
  materials: 1024,
  orders: 128
})
// 添加本地管理员状态，避免依赖store
const localIsAdmin = ref(false)

const changePasswordDialogRef = ref()

// 添加控制台相关状态
const dashboardLoading = ref(true)
const dashboardError = ref(false)

// 根据当前部分获取页面标题
const getPageTitle = () => {
  switch (currentSection.value) {
    case 'dashboard': return '系统概况';
    case 'homepage': return '主页管理';
    case 'users': return '用户管理';
    case 'vipcode': return '会员码管理';
    case 'materials': return '素材管理';
    case 'tags': return '标签管理';
    case 'tools': return '工具管理';
    case 'custom': return '定制管理';
    case 'monetize': return '变现渠道';
    case 'tutorials': return '教程管理';
    case 'tool-introductions': return '工具介绍管理';
    default: return '管理后台';
  }
}

onMounted(() => {
  // 监听路由变化
  watch(() => route.path, (newPath) => {
    console.log('路由变化:', newPath);
    console.log('当前currentSection:', currentSection.value);
  });
  console.log('Admin view mounted', {
    currentRoute: route.path,
    currentSection: currentSection.value,
    user: userStore.user,
    isAdmin: userStore.isAdmin,
    localStorageUser: localStorage.getItem('user'),
    localStorageToken: !!localStorage.getItem('token'),
    dashboardComponent: Dashboard ? 'Dashboard组件已导入' : 'Dashboard组件导入失败',
    components: Object.keys(components)
  })
  
  // 强制直接从localStorage检查是否为管理员
  checkAdminStatusFromLocalStorage()
  
  // 从localStorage直接解析用户角色
  try {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      const userData = JSON.parse(userStr)
      localIsAdmin.value = userData.role === 'admin'
      console.log('localStorage用户角色检查:', { 
        username: userData.username, 
        role: userData.role, 
        isAdmin: localIsAdmin.value,
        storeIsAdmin: userStore.isAdmin 
      })
      
      // 如果localStorage显示是管理员但store不是，尝试更新store
      if (localIsAdmin.value && !userStore.isAdmin && userData && localStorage.getItem('token')) {
        console.log('尝试使用localStorage数据恢复管理员状态')
        const token = localStorage.getItem('token')
        if (token && typeof userStore.login === 'function') {
          try {
            userStore.login(token, userData)
            console.log('已恢复用户状态, isAdmin:', userStore.isAdmin)
          } catch (error) {
            console.error('尝试调用store.login失败:', error)
          }
        }
      }
    }
  } catch (e) {
    console.error('Admin组件解析用户数据出错:', e)
  }
  
  // 延迟检查管理员权限，确保store已更新
  setTimeout(() => {
    if (!localIsAdmin.value) {
      console.log('用户不是管理员，重定向到首页')
      ElMessage.warning('您没有管理员权限')
      router.push('/')
    } else {
      console.log('用户是管理员，加载管理页面数据')
      // 如果当前在admin根路径，重定向到控制台
      if (route.path === '/admin') {
        router.push('/admin/dashboard')
      }
      // 加载管理页面数据
      loadAdminData()
    }
  }, 300)
  
  // 控制台组件加载处理
  setTimeout(() => {
    dashboardLoading.value = false
  }, 1000)
})

// 从localStorage检查是否是管理员，并更新localIsAdmin状态
const checkAdminStatusFromLocalStorage = () => {
  try {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      const userData = JSON.parse(userStr)
      localIsAdmin.value = userData.role === 'admin'
      return localIsAdmin.value
    }
  } catch (e) {
    console.error('检查localStorage管理员状态出错:', e)
  }
  return false
}

// 不再依赖store的isAdmin来判断页面跳转
watch(() => localIsAdmin.value, (isAdmin) => {
  if (!isAdmin) {
    router.push('/')
  }
})

const handleLogout = () => {
  // 使用authState登出以确保完全清除状态
  try {
    // 导入并使用authState
    import('@/utils/authState').then(module => {
      const authState = module.default;
      authState.logout();
      
      // 导航到登录页面
      router.push('/login');
    }).catch(error => {
      console.error('导入authState模块失败:', error);
      // 直接操作localStorage，避免依赖store
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('refreshToken');
      
      // 更新本地状态
      localIsAdmin.value = false;
      router.push('/login');
    });
  } catch (error) {
    console.error('登出操作失败:', error);
    // 确保本地存储被清除
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken');
    
    // 更新本地状态
    localIsAdmin.value = false;
    router.push('/login');
  }
}

const showChangePassword = () => {
  changePasswordDialogRef.value?.show()
}

const formatUsername = (username?: string) => {
  if (!username) return '用户';
  
  // 判断是否是11位数字（手机号）
  if (/^\d{11}$/.test(username)) {
    // 显示前3位和后4位，中间4位用*代替
    return username.substring(0, 3) + '****' + username.substring(7);
  }
  
  // 其他情况，保留首尾字符，中间用*代替
  const length = username.length;
  if (length <= 2) return username;
  
  const firstChar = username.charAt(0);
  const lastChar = username.charAt(length - 1);
  // 根据长度决定中间*的数量，最少1个
  const maskLength = Math.min(length - 2, 4);
  const mask = '*'.repeat(maskLength);
  
  return firstChar + mask + lastChar;
}

// 加载管理页面数据
const loadAdminData = async () => {
  try {
    // 这里可以添加加载统计数据的逻辑
    console.log('加载管理页面数据')
  } catch (error) {
    console.error('加载管理数据失败:', error)
  }
}

// 控制台组件加载处理
const handleDashboardLoad = () => {
  console.log('Dashboard组件加载成功')
  dashboardLoading.value = false
}

const handleDashboardError = (error: unknown) => {
  console.error('Dashboard组件加载失败', error)
  dashboardError.value = true
  dashboardLoading.value = false
}

// 添加重试加载Dashboard的方法
const retryLoadDashboard = () => {
  dashboardLoading.value = true
  dashboardError.value = false
  setTimeout(() => {
    dashboardLoading.value = false
  }, 1000)
}

// 测试标签管理路由
const testTagRoute = () => {
  console.log('测试按钮点击，尝试跳转到标签管理路由');
  // 暂时强制设置为管理员
  localIsAdmin.value = true;
  console.log('强制设置localIsAdmin为true');
  // 直接跳转
  router.push('/admin/tags');
  // 跳转后检查当前路由
  setTimeout(() => {
    console.log('跳转后的路由:', route.path);
    console.log('跳转后的currentSection:', currentSection.value);
  }, 500);
}

// 确保所有组件被正确注册
const components = {
  Dashboard,
  Homepage: markRaw(Homepage),
  CustomManagement: markRaw(CustomManagement),
  Materials: markRaw(Materials),
  UserManagement: markRaw(UserManagement),
  VipCodeManagement: markRaw(VipCodeManagement),
  ToolManagement: markRaw(ToolManagement),
  MonetizeManagement: markRaw(MonetizeManagement),
  TutorialManagement: markRaw(TutorialManagement),
  ToolIntroductionManagement: markRaw(ToolIntroductionManagement),
  Tags: markRaw(Tags)
}
</script>

<style scoped>
/* 添加更高特异性，确保样式生效 */
html body .admin-layout {
  display: flex;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

html body .sidebar {
  width: 250px;
  background: #001529;
  color: white;
  padding: 0; /* 移除上下内边距 */
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  z-index: 1000;
  top: 0; /* 确保紧贴顶部 */
  left: 0; /* 确保紧贴左侧 */
  margin: 0;
}

.logo {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  margin-top: 0; /* 确保logo没有顶部外边距 */
}

.menu {
  padding: 0; /* 移除菜单上下内边距 */
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: white;
  text-decoration: none;
  transition: all 0.3s;
  border-left: 4px solid transparent;
}

.menu-item:hover {
  background: rgba(255,255,255,0.1);
  border-left-color: #1989fa;
}

.menu-item.router-link-active {
  background: rgba(255,255,255,0.1);
  border-left-color: #1989fa;
  font-weight: bold;
}

.menu-item .el-icon {
  margin-right: 10px;
  font-size: 18px;
}

html body .main-content {
  flex: 1;
  margin-left: 250px; /* 与侧边栏宽度相同 */
  display: flex;
  flex-direction: column;
  margin-top: 0; /* 确保没有顶部外边距 */
  padding-top: 0; /* 确保没有顶部内边距 */
  overflow-y: auto;
  position: relative; /* 确保定位正确 */
  top: 0;
}

.header {
  background: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  height: 24px; /* 明确指定高度 */
  position: sticky; /* 使header保持在顶部 */
  top: 0;
  z-index: 10;
}

.content {
  flex: 1;
  padding: 20px;
  background: #f0f2f5;
  overflow-y: auto;
  height: calc(100vh - 64px); /* 减去header的高度 */
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info button {
  padding: 8px 16px;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.user-info button:hover {
  background: #ff7875;
}

.user-name {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  background-color: #f5f7fa;
  border-radius: 16px;
  transition: all 0.3s;
  border: 1px solid #e6e6e6;
}

.user-name:hover {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409EFF;
}

/* 统计卡片样式 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.stat-card .el-icon {
  font-size: 36px;
  color: #409EFF;
  margin-right: 16px;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.stat-label {
  font-size: 14px;
  color: #909399;
  margin-top: 4px;
}

/* 管理内容区域样式 */
.admin-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  min-height: calc(100vh - 180px);
}

/* 各个管理部分样式 */
.dashboard-section,
.homepage-section,
.users-section,
.materials-section,
.tools-section,
.orders-section,
.custom-section,
.monetize-section,
.tutorials-section,
.tags-section,
.tool-introductions-section {
  margin-top: 20px;
}

/* 面包屑样式 */
.breadcrumb {
  font-size: 16px;
  color: #606266;
}
</style>